<template>
    <div class="container">
        <Title v-if="!isDoctor" :text="dottore.nome + ' ' + dottore.cognome + ' / ' + nome_pratica" :backArrow="true" :backVue="getBackVue()"/>
        <Title v-if="isDoctor" :text="nome_pratica" :backArrow="true" :backVue="getBackVue()"/>
        <ListaBolle class="list" :id_pratica="id_pratica" />
    </div>
</template>

<script>
import ListaBolle from '@/components/Lista-Bolle.vue';
import Title from '@/components/Title.vue';

export default {
    name: 'Bolle',
    components: {
        ListaBolle,
        Title
    },
    data() {
        return {
            id_pratica: this.$route.params.id,
            nome_pratica: this.$route.params.nome,
            dottore: this.$store.getters['getDottore'],
            user: this.$store.getters['getUser']
        }
    },
    computed: {
        isDoctor: function() {
            var isDoctor = this.user.user_type.includes("dottori") && !this.user.user_type.includes("gestori");
            return isDoctor;
        }
    },
    methods: {
        getBackVue: function(){
            let usertype = this.$store.getters['getUser'].user_type;
            if (usertype.includes("gestori") || usertype.includes("admin")){
                return "dottore/" + this.dottore.uid;
            }
            else {
                this.$store.dispatch("toggleDashboard", false)
                return "dashboard";
            }
        }
    }
}
</script>

<style scoped>
    .container {
        width: 70%;
        max-width: 800px;
    }
    .list{
        padding-top: 35px;
    }
</style>